import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { createLocaleBackend, I18N_OPTIONS } from '@/i18n/localeBackend';

// Ленивая подгрузка локалей: каждый src/locales/*.json Vite собирает в
// отдельный чанк, в основной бандл не попадает ни один. i18next через
// createLocaleBackend тянет только активную локаль (+ 'en' как fallback, если
// они различаются). Новый язык = новый json-файл, без правки этого модуля.
const localeLoaders = import.meta.glob('./locales/*.json') as Record<
    string,
    () => Promise<{ default: Record<string, string> }>
>;

// Файловый сабтег языка для i18n: язык (+письменность), без региона —
// 'en-US' → 'en', но 'zh-Hans' → 'zh-hans' (письменности имеют РАЗНЫЕ словари,
// иначе пара zh-Hans/zh-Hant перезаписывала бы друг друга). Зеркало
// CoreLangRepository::fileSubtag() на бэке.
// Fallback 'ru' — для Storybook и тестов, где window.App недоступен.
const rawLocale = (window.App?.locale ?? 'ru').toLowerCase();
const [langPart, secondPart] = rawLocale.split('-');
const language = secondPart && secondPart.length === 4 ? `${langPart}-${secondPart}` : langPart;

// Резолвится, когда словари активной локали и fallback загружены. Точки входа
// ОБЯЗАНЫ дождаться его до первого рендера (main.islands.tsx, dev/main.dev.tsx,
// .storybook/preview.tsx): редьюсеры и компоненты зовут getTranslation()/t()
// синхронно и до готовности получили бы сырые ключи.
const i18nReady: Promise<unknown> = i18n
    .use(createLocaleBackend(localeLoaders))
    .use(initReactI18next)
    .init({ ...I18N_OPTIONS, lng: language });

export { language, i18nReady };
export default i18n;
